import { useCallback, useEffect } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { batch, useSignal } from "@preact/signals-react"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"
import { reportFormDataInnit, reportFormNumSearches } from "Pages/ReportsAlerts/Reports/@signals"

export default function useCloneReport(idReport) {
	const { backendUrl } = useReportBackendApiPath()
	const isLoading = useSignal(false)

	const setLoading = () => isLoading.value = true

	const onClone = useCallback(() => {
		isLoading.value = true
		getSubmit(`${backendUrl}/list`, { id: idReport })
			.then(data => batch(() => {
				reportFormDataInnit({ ...data, title: `Clone Report: ${data.name}` })
				reportFormNumSearches.value = data.numSearches
				isLoading.value = false
			}))
	}, [idReport])

	useEffect(() => {
		if (isLoading.value) onClone()
	}, [isLoading.value])

	return {
		setLoading,
		isLoading: isLoading.value
	}

}